import { defineConfig } from 'web-helper'

export const config = defineConfig(import.meta.env)
